import { Button, Card, Col, Form, Input, message, Row, Select, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { FloatingCubes } from '~/components';
import { useScreenSize } from '~/hooks';
import { useCreateRegisterMutation } from '~/hooks/register/useRegisterForm';

const { Title } = Typography;
const { Option } = Select;

const solutions = [
  'ERP Mini',
  'CRM',
  'DMS',
  'PM',
  'HRM',
  'PMS',
  'MES',
  'TMS',
  'WMS',
  'EAM',
];

const packages = ['Cơ bản', 'Tiêu chuẩn', 'Nâng cao'];

const RegisterPackagePage = () => {
  const { isMobile } = useScreenSize();
  const location = useLocation();
  const { packageName, solutionName } = location.state || {};
  const { createRegister, isLoading } = useCreateRegisterMutation();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
       try {  
      await createRegister(values);
      message.success('Bạn đã đăng ký gói giải pháp thành công!');
      form.resetFields();
    } catch (error) {
      console.error(error);
      message.error('Gửi tin nhắn thất bại. Vui lòng thử lại sau.');
    }

  };

  return (
    <div style={{ position: 'relative', padding: '30px', fontSize: 16}}>
      <div className="animated-bg" style={{ background: 'rgba(245, 158, 11, 0.08)' }}>
        <FloatingCubes color='#f59e0b' />
      </div>
      <div className="hero-blur-overlay"></div>
      <Row justify="center" style={{ position: 'relative', zIndex: 1 }}>
        <Col xs={24} sm={24} md={20} lg={20} xl={16 } xxl={10}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.85)',
            backdropFilter: 'blur(10px)',
            borderRadius: '15px',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            border: '1px solid rgba(255, 255, 255, 0.18)',
            padding: isMobile ? 10 : 40 
          }}>
            <Title level={2} style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>
              Đăng ký tư vấn gói giải pháp
            </Title>
            <Form
              name="register-package"
              initialValues={{
                system: solutionName,
                packagePrice: packageName,
              }}
              onFinish={onFinish}
              layout="vertical"
              size="large"
            >
              <Form.Item
                name="name"
                label="Họ và tên"
                rules={[{ required: true, message: 'Vui lòng nhập họ và tên!' }]}
              >
                <Input placeholder="Nguyễn Văn A" />
              </Form.Item>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[{ required: true, type: 'email', message: 'Vui lòng nhập email hợp lệ!' }]}
                  >
                    <Input placeholder="example@email.com" />
                  </Form.Item>
                  <Form.Item
                    name="phone"
                    label="Điện thoại"
                    rules={[{ required: true, message: 'Vui lòng nhập số điện thoại!' }]}
                  >
                    <Input placeholder="0123 456 789" />
                  </Form.Item>
              

              <Form.Item
                name="system"
                label="Giải pháp"
                rules={[{ required: true, message: 'Vui lòng chọn giải pháp!' }]}
              >
                <Select placeholder="Chọn giải pháp bạn quan tâm">
                  {solutions.map((solution) => (
                    <Option key={solution} value={solution}>
                      {solution}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="packagePrice"
                label="Gói"
                rules={[{ required: true, message: 'Vui lòng chọn gói!' }]}
              >
                <Select placeholder="Chọn gói dịch vụ">
                  {packages.map((pkg) => (
                    <Option key={pkg} value={pkg}>
                      {pkg}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item style={{ marginTop: '30px' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={isLoading}
                  size="large"
                  style={{
                    background: 'linear-gradient(45deg, #fbad16, #f6d365)',
                    border: 'none',
                    color: '#fff',
                    fontWeight: 'bold',
                    height: '50px',
                  }}
                >
                  Gửi đăng ký
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default RegisterPackagePage;
